<template>
  <div class="smart_table" ref="tableRef">
    <Table
      :loading="props.loading"
      :scroll="{ y: tableHeight, x: '100%' }"
      :columns="dataMap.newColumns"
      :dataSource="dataSource"
      @change="handleChange"
      :bordered="false"
      @resizeColumn="handleResizeColumn"
      :pagination="{
        size: 'small',
        'show-total': (total = 0) => `${lang('共')}${total}${lang('条')}`,
        total: props.total,
        current: props.current,
        pageSize: props.pageSize || 10,
        showSizeChanger: true,
        defaultPageSize: 10,
        pageSizeOptions: ['10', '20', '50', '100'],
        placement: 'topRight'
      }"
      :rowClassName="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      v-bind="$attrs"
    >
      <!-- 添加汇总行插槽 -->
      <template #summary v-if="props.option?.summary?.show">
        <a-table-summary-row>
          <template v-for="(value, index) in summaryData" :key="index">
            <a-table-summary-cell :index="index" style="text-align: center;">
              <!-- 为第一个单元格设置特殊样式 -->
              <span :style="props.option?.summary?.titleStyle">{{ value }}</span>
            </a-table-summary-cell>
          </template>
        </a-table-summary-row>
      </template>
    </Table>
    <div class="show_select_total" v-if="option.selection && props.total !== 0">
      {{ lang('已选') }}{{ selectRows.length }}{{ lang('条') }}
    </div>
  </div>
</template>

<script lang="tsx" setup name="SmartTable">
import { Table } from 'ant-design-vue'
import { reactive, ref, watchEffect, computed } from 'vue'
// import { useTableHeight } from '../../hooks/useTableHeight'
import type { Values } from '../common'
import LabelTip from './components/LabelTip.vue'
import { moneyFormat } from '../utils/tools'

import { inject } from 'vue'

const lang = inject('lang')
const tableRef = ref()

// const [tableHeight, updateTableHeight] = useTableHeight('500')

const tableHeight = '500'
const updateTableHeight = () =>{

}

const emit = defineEmits(['change'])
const props = defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  columns: {
    type: Array,
    default: () => []
  },
  pageSize: {
    type: Number,
    default: 10
  },
  dataSource: {
    type: Array,
    default: () => []
  },
  total: {
    type: Number,
    default: 0
  },
  current: {
    type: Number,
    default: 1
  },
  showIndex: {
    type: Boolean,
    default: false
  },
  selectRows: {
    type: Array,
    default: () => []
  },
  option: {
    type: Object,
    default: () => ({})
  }
})

const dataMap: { newColumns: Values[] } = reactive({
  newColumns: []
})

const getSelectLabel = (item) => {
  return item?.props?.label || 'label'
}
const getSelectValue = (item) => {
  return item?.props?.value || 'value'
}

watchEffect(() => {
  dataMap.newColumns = props.columns.map((item: any) => {
    const i = Object.assign({}, item)
    if (i.moneyFormat) {
      i.align = 'right'
    }
    if (i.labelTip) {
      i.title = <LabelTip title={lang(i.title)} tip={lang(i.labelTip)} />
    }else{
      i.title = lang(i.title)
    }

    if (i.viewProp) {
      // 如果有viewProp 使用viewProp渲染数据
      i.customRender = ({ record }: Record<any, any>) => {
        const text = record[i.viewProp]
        const val = text !== null && text !== undefined && text !== '' ? text : '-'
        return i.lang ? lang(val) : val
      }
    } else if (i.render) {
      // 如果有render方法就重写customRender
      i.customRender = i.render
    } else if (['radio-button', 'select', 'radio'].includes(i.type) && i.dicData && !i.customRender) {
      // 如果有字典数据自动从字典数据中获取
      const enumMap = i.dicData.reduce((acc: any, item: any) => {
        acc[item[getSelectValue(i)]] = item[getSelectLabel(i)]
        return acc
      }, {})

      const iconMap = i.dicData.reduce((acc: any, item: any) => {
        acc[item[getSelectValue(i)]] = item.enumIcon
        return acc
      }, {})

      i.customRender = ({ text }: Record<any, any>) => {
        const val = enumMap[text] || '-'
        const icon = iconMap[text]
        return (
          <div>
            {icon && <a-badge status={icon} />}
            {val}
          </div>
        )
      }
    } else if (!i.customRender) {
      i.customRender = ({ text }: Record<any, any>) => {
        const val = text !== null && text !== undefined && text !== '' ? text : '-'
        if (i.moneyFormat) {
          const txt = moneyFormat(val)
          if (val < 0) {
            return <span style="color: red">{txt}</span>
          } else {
            return txt
          }
        } else {
          return i.lang ? lang(val) : val
        }
      }
    }

    // 填充默认宽度
    if (i.width === undefined) {
      i.width = 150
    }
    // 超过宽度将自动省略
    i.ellipsis = { showTitle: true }
    // 是否可拖动调整宽度，此时 width 必须是 number 类型
    i.resizable = true
    return i
  })
  if (props.showIndex) {
    dataMap.newColumns.unshift({
      dataIndex: 'key',
      title: lang('序号'),
      key: 'key',
      width: 100,
      align: 'center',
      fixed: 'left',
      ellipsis: { showTitle: true },
      customRender: ({ index }: Values) => {
        return (props.current - 1) * props.pageSize + index + 1
      }
    })
  }
})

const handleChange = (...arg: any) => {
  emit('change', ...arg)
}
const handleResizeColumn = (w: any, col: Record<any, any>) => {
  col.width = w
}

// 获取汇总数据
const summaryData = computed(() => {
  console.log(props.option.summary.method().data)
  if (props.option?.summary?.method) {
    return props.option.summary.method().data
  }
  return []
})


defineExpose({
  updateTableHeight
})
</script>
<style lang="less" scoped>
.smart_table :deep(.ant-table) {
  border-bottom: 1px solid #e4e4e4;
  [data-doc-theme='light'] .ant-table-striped :deep(.table-striped) td {
    background-color: #fafafa;
  }
  [data-doc-theme='dark'] .ant-table-striped :deep(.table-striped) td {
    background-color: rgb(29, 29, 29);
  }
}
</style>
<style lang="less">
.smart_table {
  position: relative;
  /* 覆盖分页条数选择框的样式，使其从下向上弹出 */
  .ant-select-dropdown-placement-bottomLeft,
  .ant-select-dropdown-placement-bottomRight {
    transform-origin: bottom center !important;
    transition: none !important; /* 禁用动画避免闪烁 */
    bottom: 100% !important;
    top: auto !important;
    left: 0 !important;
  }
  .ant-table-wrapper .ant-table-thead > tr > th {
    background-color: #fafafa;
    font-weight: 400;
    padding: 10px 10px;
  }
  .show_select_total {
    position: absolute;
    bottom: 22px;
  }

  // 添加汇总行标题样式
  :deep(.summary-title) {
    color: #1890ff;
    font-weight: bold;
    width: 150px;
    display: inline-block;
  }
}

.table-striped td {
  background-color: #fafafa !important;
}
</style>
